import React from 'react';
import AnimatedNewsBlock from '../components/AnimatedNewsBlock';
import NewsSectionLink from '../components/NewsSectionLink';
import '../styles/Subsections.css';

import dinazLogo from '../img/dinazLogo.png';
import skalaLogo from '../img/skala1911Logo.jpg';
import rukhLogo from '../img/rukhLogo.png';
import podillyaLogo from '../img/podillyaLogo.png';
import metalurhLogo from '../img/metalurhLogo.png';
import nyvaVinnytsiaLogo from '../img/nyvaVinnytsiaLogo.png';
import atletLogo from '../img/atletLogo.png';
import vilkhivtsiLogo from '../img/vilkhivtsiLogo.png';
import rebelLogo from '../img/rebelLogo.png';
import trostyanetsLogo from '../img/trostyanetsLogo.png';
import penuelLogo from '../img/penuelLogo.png';
import bratslavLogo from '../img/bratslavLogo.png';
import dnisterZalishchykyLogo from '../img/dnisterZalishchykyLogo.png';
import avangardLozovaLogo from '../img/avangardLozovaLogo.png';
import carbonCherkasyLogo from '../img/carbonCherkasyLogo.png';

export const secondLeagueClubs = [
  { name: 'Рух', image: rukhLogo, link: '/football-ukraine/rukh' },
  { name: 'Поділля', image: podillyaLogo, link: '/football-ukraine/podillya' },
  { name: 'Металург', image: metalurhLogo, link: '/football-ukraine/metalurh' },
  { name: 'Діназ', image: dinazLogo, link: '/football-ukraine/dinaz' },
  { name: 'Скала 1911', image: skalaLogo, link: '/football-ukraine/skala-1911' },
  {
    name: 'Нива Вінниця',
    image: nyvaVinnytsiaLogo,
    link: '/football-ukraine/nyva-vinnytsia',
  },
  { name: 'Атлет', image: atletLogo, link: '/football-ukraine/atlet' },
  {
    name: 'Вільхівці',
    image: vilkhivtsiLogo,
    link: '/football-ukraine/vilkhivtsi',
  },
  { name: 'Ребел', image: rebelLogo, link: '/football-ukraine/rebel' },
  {
    name: 'Тростянець',
    image: trostyanetsLogo,
    link: '/football-ukraine/trostyanets',
  },
  { name: 'Пенуел', image: penuelLogo, link: '/football-ukraine/penuel' },

  {
    name: 'Брацлав',
    image: bratslavLogo,
    link: '/football-ukraine/bratslav',
  },
  {
    name: 'Дністер',
    image: dnisterZalishchykyLogo,
    link: '/football-ukraine/dnister-zalishchyky',
  },
  {
    name: 'Авангард',
    image: avangardLozovaLogo,
    link: '/football-ukraine/avangard-lozova',
  },
  {
    name: 'Карбон',
    image: carbonCherkasyLogo,
    link: '/football-ukraine/carbon-cherkasy',
  },
];

const SecondLeagueClubs = () => {
  return (
    <AnimatedNewsBlock currentPage="second-league">
      <div className="subsections-container">
        {secondLeagueClubs.map((club) => (
          <NewsSectionLink
            to={club.link}
            section={club.name}
            key={club.link}
            className="subsection-item"
          >
            <img
              src={club.image}
              alt={`Логотип ФК ${club.name}`}
              className="club-logo-small"
            />

            <span className="subsection-title">{club.name}</span>
          </NewsSectionLink>
        ))}
      </div>
    </AnimatedNewsBlock>
  );
};

export default SecondLeagueClubs;
